import React, { FC, ReactNode } from 'react';
import { Divider, Grid, Paper, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { IVariables } from './types';
import PeriodSelect from './PeriodSelect';

interface IProps extends WithStyles<typeof styles> {
  title: ReactNode;
  children: ReactNode;
  variables: IVariables;
  onChange: (variables: IVariables) => void;
}

const CHART_HEIGHT = 300;

const styles = (theme: Theme) =>
  createStyles({
    gutter: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    wrapper: {
      position: 'relative',
      height: CHART_HEIGHT,
      padding: 16,
    },
  });

const Widget: FC<IProps> = ({ classes, title, children, variables, onChange }) => (
  <Paper>
    <div className={classes.gutter}>
      <Grid container alignItems="center" justify="space-around">
        <Grid item xs>
          <Typography variant="subtitle2">{title}</Typography>
        </Grid>
        <Grid item>
          <PeriodSelect variables={variables} onChange={onChange} />
        </Grid>
      </Grid>
    </div>
    <Divider />
    <div className={classes.wrapper}>{children}</div>
  </Paper>
);

export default withStyles(styles)(Widget);
